<template>
  <el-table :data="tableServerInfo" border>
    <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
    <el-table-column prop="orderNum" label="ICCID" align="center"></el-table-column>
    <el-table-column prop="productName" label="套餐名" align="center"></el-table-column>
    <el-table-column prop="productName" label="消费金额" align="center"></el-table-column>
    <el-table-column prop="monthFlow" label="当前余额" align="center"></el-table-column>
    <el-table-column prop="status" label="更新时间" align="center"></el-table-column>
  </el-table>
</template>
<script>
import { cardProduct } from "@/api/api.js"; //资费列表
export default {
  props: {
    userId: {
      type: [String]
    }
  },
  data() {
    return{
      tableServerInfo:[],
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      // let params = {
      //   iccid:this.$route.query.iccid
      // };
      // cardProduct(params).then(res => {
      //   if(res.data.code == 200){
      //     this.tableServerInfo = res.data.data;
      //   }
      // })
    },
  },
  created() {}
};
</script>

<style scoped lang="less">

</style>


